<template>
  <div id="client-access-list">

      <b-card>
        <b-alert
          :show="!!importJob"
          :variant="importJobVariant"
        >
          <div v-if="importJob" class="alert-body">
            <strong>{{ importJobTypeLabel }}</strong> - {{ importJobStatusLabel }}
            <span v-if="isImportRunning">({{ importJobPhaseLabel }})</span>
            <span class="ml-1">Tempo: {{ importJobDuration }}</span>
            <div class="mt-50">
              <span v-for="counter in importJobCounters" :key="counter.label" class="mr-2">
                {{ counter.label }}: <strong>{{ counter.value }}</strong>
              </span>
            </div>
            <div v-if="importJob.message" class="mt-50">{{ importJob.message }}</div>
          </div>
        </b-alert>
        <b-tabs>
          <b-tab title="IPV4">
            <b-row>
              <b-col md="6">
                <label for="ipv4-database" class="mt-1">Importar base de dados IPV4</label>
                <b-form-file
                  id="ipv4-database"
                  @change="onChangeFileIpv4"
                  accept=".csv"
                  placeholder="Adicione um arquivo"
                  drop-placeholder="Insira um arquivo"
                  browse-text="Pesquisar"
                />
              </b-col>
              <b-col class="button-geolocation">
                <b-button
                  :disabled="importingIpv4Database || isImportRunning"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  :class="{'button-geolocation-disable': importingIpv4Database || isImportRunning}"
                  @click="importIpv4Database"
                >
                  Enviar
                </b-button>
              </b-col>
              <b-col class="button-geolocation">
                <h6 v-if="importingIpv4Database">Enviando arquivos...</h6>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="6">
                <label for="asn-database" class="mt-1">Importar base de dados ASN</label>
                <b-form-file
                  id="asn-database"
                  @change="onChangeFileAsn"
                  accept=".json"
                  placeholder="Adicione um arquivo"
                  drop-placeholder="Insira um arquivo"
                  browse-text="Pesquisar"
                />
              </b-col>
              <b-col class="button-geolocation">
                <b-button
                  :disabled="importingAsnDatabase || isImportRunning"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  :class="{'button-geolocation-disable': importingAsnDatabase || isImportRunning}"
                  @click="importAsnDatabase"
                >
                  Enviar
                </b-button>
              </b-col>
              <b-col class="button-geolocation">
                <h6 v-if="importingAsnDatabase">Enviando arquivos...</h6>
              </b-col>
            </b-row>
            <br>
            <b-overlay
              variant="white"
              :show="tableLoadingIpv4"
              spinner-variant="primary"
              blur="0"
              opacity=".75"
              rounded="sm"
            >
            <custom-g-table 
              v-if="displayTableIpv4" 
              ref="custom-table" 
              :displayLoading="tableLoadingIpv4" 
              :fields="fieldsIpv4"
              :items="dataIpv4" 
              :totalRows="totalRowsIpv4" 
              :limit="limitIpv4" 
              :hasDeleteButton="false" 
              :hasUpdateDataButton="true"
              :hasAdvancedFilterButton="true" 
              :hasExportDataButton="false" 
              :hasPerPageSelect="true"
              :advancedFilters="advancedFiltersIpv4" 
              @changePage="onChangePageIpv4" 
              @onColumnFilter="onFilterIpv4"
              @updateData="updateDataIpv4" 
              @fetchAdvancedFilter="onFilterIpv4"
              @limitChanged="onLimitChangedIpv4" 
            />
          </b-overlay>
          </b-tab>
          <!--<b-tab title="IPV6">
            <b-row>
              <b-col md="6">
                <label for="ipv6-database" class="mt-1">Importar base de dados IPV6</label>
                <b-form-file
                  id="ipv6-database"
                  @change="onChangeFileIpv6"
                  accept=".csv"
                  placeholder="Adicione um arquivo"
                  drop-placeholder="Insira um arquivo"
                  browse-text="Pesquisar"
                />
              </b-col>
              <b-col class="button-geolocation">
                <b-button
                  :disabled="importingIpv6Database"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  :class="{'button-geolocation-disable': importingIpv6Database}"
                  @click="importIpv6Database"
                >
                  Enviar
                </b-button>
              </b-col>
              <b-col class="button-geolocation">
                <h6 v-if="importingIpv6Database">Enviando arquivos...</h6>
              </b-col>
            </b-row>
            <br>
            <b-overlay
              variant="white"
              :show="tableLoadingIpv6"
              spinner-variant="primary"
              blur="0"
              opacity=".75"
              rounded="sm"
            >
            <custom-g-table 
              v-if="displayTableIpv6" 
              ref="custom-table" 
              :displayLoading="tableLoadingIpv6" 
              :fields="fieldsIpv6"
              :items="dataIpv6" 
              :totalRows="totalRowsIpv6" 
              :limit="limitIpv6" 
              :hasDeleteButton="false" 
              :hasUpdateDataButton="true"
              :hasAdvancedFilterButton="true" 
              :hasExportDataButton="false" 
              :hasPerPageSelect="true"
              :advancedFilters="advancedFiltersIpv6" 
              @changePage="onChangePageIpv6" 
              @onColumnFilter="onFilterIpv6"
              @updateData="updateDataIpv6" 
              @fetchAdvancedFilter="onFilterIpv6"
              @limitChanged="onLimitChangedIpv6" 
            />
          </b-overlay>
          </b-tab>-->

        </b-tabs>
      </b-card>
    
  </div>
</template>

<script>
import { 
  BCard, 
  BTab, 
  BTabs, 
  BButton, 
  BCol, 
  BRow, 
  // BFormGroup, 
  BFormFile,
  BOverlay,
  BAlert
} from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import AppConstants from "@/appConstants";
import geolocationService from "@/providers/geolocationService";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
// import flatPickr from "vue-flatpickr-component";

const IMPORT_STATUS_POLLING_MS = 5000;
const IMPORT_TYPE_LABELS = {
  'ipv4-csv': 'Importação da base IPV4 (CSV)',
  'asn-json': 'Importação da base ASN (JSON)',
  'reindex-elastic': 'Reindexação do Elasticsearch',
};
const IMPORT_STATUS_LABELS = {
  running: 'Em andamento',
  completed: 'Concluída',
  failed: 'Falhou',
};
const IMPORT_PHASE_LABELS = {
  queued: 'Iniciando',
  mongo: 'Gravando no banco de dados',
  cleanup: 'Removendo faixas que não estão no arquivo',
  elasticsearch: 'Indexando no Elasticsearch',
  done: 'Finalizado',
};

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BAlert,
    BCard,
    BTab,
    BTabs,
    BButton,
    BCol,
    BRow,
    // BFormGroup,
    BOverlay,
    CustomGTable,
    // flatPickr,
    BFormFile
  },
  data() {
    return {
      displayTableIpv4: false, 
      displayTableIpv6: false, 
      // sortField: {},
      dataIpv4: [],
      dataIpv6: [],
      totalRowsIpv4: 0,
      totalRowsIpv6: 0,
      limitIpv4: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      limitIpv6: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      pageIpv4: 1,
      pageIpv6: 1,
      tableLoadingIpv4: true,
      tableLoadingIpv6: true,
      fileIpv4: null,
      fileIpv6: null,
      fileAsn: null,
      importingIpv4Database: false,
      importingIpv6Database: false,
      importingAsnDatabase: false,
      importJob: null,
      importStatusTimer: null,
      now: Date.now(),
      syncParamsForm: {
        origin: null
      },
      isSyncing: false,
      filters: {},
      fieldsIpv4: [
        { field: "dt_create", label: "Data de Criação", type: "custom_date", sortable: false },
        { field: "ip_from", label: "IP - Início", sortable: false },
        { field: "ip_to", label: "IP - Fim", sortable: false },
        // { field: "ip_range", label: "Range de Ip's", sortable: false },
        { field: "continent_code", label: "Código do Continente", sortable: false },
        { field: "country_code", label: "Código do País", sortable: false },
        // { field: "country_name", label: "País", sortable: false },
        { field: "region_name", label: "Região", sortable: false },
        { field: "city_name", label: "Cidade", sortable: false },
        // { field: "zip_code", label: "Código Postal", sortable: false },
        { field: "longitude", label: "Longitude", sortable: false },
        { field: "latitude", label: "Latitude", sortable: false },
        { field: "asn", label: "ASN", sortable: false },
        { field: "asn_name", label: "Nome ASN", sortable: false },
        { field: "asn_domain", label: "Domínio ASN", sortable: false },
        // { field: "time_zone", label: "Fuso Horário", sortable: false },
      ],
      fieldsIpv6: [
        { field: "dt_create", label: "Data de Criação", type: "custom_date", sortable: false },
        { field: "ip_from", label: "IP - Início", sortable: false },
        { field: "ip_to", label: "IP - Fim", sortable: false },
        { field: "country_code", label: "Código do País", sortable: false },
        { field: "country_name", label: "País", sortable: false },
        { field: "region_name", label: "Região", sortable: false },
        { field: "city_name", label: "Cidade", sortable: false },
        { field: "zip_code", label: "Código Postal", sortable: false },
        { field: "longitude", label: "Longitude", sortable: false },
        { field: "latitude", label: "Latitude", sortable: false },
        { field: "time_zone", label: "Fuso Horário", sortable: false },
      ],
      advancedFiltersIpv4: [
        { field: "ip", label: "IP", type: 'input', value: '', size: 2 },
        // { field: "country_name", label: "País", type: 'input', value: '', size: 2 },
        { field: "country_code", label: "Código País", type: 'input', value: '', size: 2 },
        { field: "region_name", label: "Região", type: 'input', value: '', size: 2 },
        { field: "city_name", label: "Cidade", type: 'input', value: '', size: 2 },
        // { field: "zip_code", label: "Código Postal", type: 'input', value: '', size: 2 },
        { field: "longitude", label: "Longitude", type: 'input', value: '', size: 2 },
        { field: "latitude", label: "Latitude", type: 'input', value: '', size: 2 },
      ],
      advancedFiltersIpv6: [
        { field: "ip", label: "IP", type: 'input', value: '', size: 2 },
        { field: "country_name", label: "País", type: 'input', value: '', size: 2 },
        { field: "country_code", label: "Código País", type: 'input', value: '', size: 2 },
        { field: "region_name", label: "Região", type: 'input', value: '', size: 2 },
        { field: "city_name", label: "Cidade", type: 'input', value: '', size: 2 },
        { field: "zip_code", label: "Código Postal", type: 'input', value: '', size: 2 },
        { field: "longitude", label: "Longitude", type: 'input', value: '', size: 2 },
        { field: "latitude", label: "Latitude", type: 'input', value: '', size: 2 },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Geolocalização");
    this.setInitialTableFilters();
    this.loadImportStatus();
  },
  beforeDestroy() {
    clearTimeout(this.importStatusTimer);
  },
  computed: {
    isImportRunning() {
      return !!this.importJob && this.importJob.status === 'running';
    },
    importJobVariant() {
      if (!this.importJob || this.importJob.status === 'running') return 'primary';
      return this.importJob.status === 'completed' ? 'success' : 'danger';
    },
    importJobTypeLabel() {
      return IMPORT_TYPE_LABELS[this.importJob.type] || this.importJob.type;
    },
    importJobStatusLabel() {
      return IMPORT_STATUS_LABELS[this.importJob.status] || this.importJob.status;
    },
    importJobPhaseLabel() {
      return IMPORT_PHASE_LABELS[this.importJob.phase] || this.importJob.phase;
    },
    importJobDuration() {
      const seconds = this.isImportRunning
        ? Math.max(0, Math.round((this.now - new Date(this.importJob.startedAt).getTime()) / 1000))
        : this.importJob.durationSeconds || 0;
      return new Date(seconds * 1000).toISOString().substring(11, 19);
    },
    importJobCounters() {
      const job = this.importJob;
      const counters = [
        { label: 'Lidos', value: job.read },
        { label: 'Inseridos', value: job.inserted },
        { label: 'Atualizados', value: job.updated },
        { label: 'Sem correspondência', value: job.unmatched },
        { label: 'Ignorados', value: job.skipped },
        { label: 'Falhas', value: job.failed },
        { label: 'Removidos', value: job.staleRemoved },
        { label: 'Indexados', value: job.indexed },
        { label: 'Falhas na indexação', value: job.indexFailed },
      ];
      // a reindexacao nao le arquivo, entao so mostra os contadores do Elasticsearch
      const visible = job.type === 'reindex-elastic'
        ? counters.filter(counter => ['Indexados', 'Falhas na indexação'].includes(counter.label))
        : counters;
      return visible.map(counter => ({ ...counter, value: Number(counter.value || 0).toLocaleString('pt-BR') }));
    },

    searchParamsIpv4() {
      const params = buildParamsRouteQuery(this.$route.query);

      params.append("page", this.pageIpv4);
      params.append("limit", this.limitIpv4);
      params.append("database", "ipv4database");

      // this.advancedFiltersIpv4.forEach(filter => {
      //   if (filter.value) { 
      //     params.append(filter.field, filter.value);
      //   }
      // });
      return params;
    },
    searchParamsIpv6() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.pageIpv6);
      params.append("limit", this.limitIpv6);
      params.append("database", "ipv6database");
      return params;
    },
  },
  methods: {
    loadImportStatus(jobId) {
      geolocationService
        .getImportStatus(jobId)
        .then((job) => this.onImportJobUpdated(job))
        .catch((err) => {
          console.log(err);
          // o jobId deixa de existir se o geolocation reiniciar (404); segue acompanhando pela importacao mais recente
          if (this.isImportRunning) this.scheduleImportStatus(true);
        });
    },
    scheduleImportStatus(latest = false) {
      clearTimeout(this.importStatusTimer);
      const jobId = latest ? undefined : this.importJob && this.importJob.id;
      this.importStatusTimer = setTimeout(() => this.loadImportStatus(jobId), IMPORT_STATUS_POLLING_MS);
    },
    onImportJobUpdated(job) {
      // corpo vazio = nenhuma importacao registrada (o apiService devolve a resposta do axios, sem id)
      if (!job || !job.id) {
        if (this.isImportRunning) this.onImportJobLost();
        return;
      }
      const wasRunning = this.isImportRunning && this.importJob.id === job.id;
      this.importJob = job;
      this.now = Date.now();
      if (job.status === 'running') {
        this.scheduleImportStatus();
        return;
      }
      if (!wasRunning) return;
      if (job.status === 'completed') {
        messagesNotifyHelper.successNotify("Geolocalização", job.message || "Importação feita com sucesso");
        this.loadDataIpv4();
      } else {
        messagesNotifyHelper.errorNotify("Geolocalização", `Erro na importação: ${job.message}`);
      }
    },
    onImportJobLost() {
      this.importJob = {
        ...this.importJob,
        status: 'failed',
        phase: 'done',
        durationSeconds: Math.round((Date.now() - new Date(this.importJob.startedAt).getTime()) / 1000),
        message: 'O acompanhamento da importação foi perdido porque o serviço de geolocalização foi reiniciado. Confira os dados e, se necessário, envie o arquivo novamente.',
      };
      messagesNotifyHelper.errorNotify("Geolocalização", this.importJob.message);
    },
    onImportStartError(err) {
      // o interceptor do axios rejeita com o corpo da resposta (error.response.data)
      const data = (err && err.response && err.response.data) || err;
      if (data && data.job) this.onImportJobUpdated(data.job);
      messagesNotifyHelper.errorNotify(
        "Geolocalização",
        `Erro na importação: ${(data && data.message) || err}`
      );
      console.log(err);
    },
    onLimitChangedIpv4(newLimit) {
      this.limitIpv4 = newLimit;
      this.loadDataIpv4();
    },
    onLimitChangedIpv6(newLimit) {
      this.limitIpv6 = newLimit;
      this.loadDataIpv6();
    },
    setInitialTableFilters() {
      // Object.keys(this.urlQuery).forEach(item => {
      //   this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      // });
      Object.keys(this.urlQuery).forEach(item => {
        this.advancedFiltersIpv4[this.advancedFiltersIpv4.findIndex(val => val.field == item)].value = this.urlQuery[item];
      });
      this.loadDataIpv4();
      // this.loadDataIpv6();
    },
    onChangePageIpv4(page) {
      this.pageIpv4 = page;
      this.loadDataIpv4();
    },
    onChangePageIpv6(page) {
      this.page = page;
      this.loadDataIpv6();
    },
    onFilterIpv4(data) {
      console.log('onFilter', data);
      this.filters = data;
      setRouteQuery(data, this.$route.query);
      this.loadDataIpv4();
    },
    onFilterIpv6(data) {
      console.log('onFilter', data);
      this.filters = data;
      setRouteQuery(data, this.$route.query);
      this.loadDataIpv6();
    },
    loadDataIpv4() {
      this.dataIpv4 = [];
      this.tableLoadingIpv4 = true;
      // this.displayTable = false;
      geolocationService
        .getAllGeolocation(this.searchParamsIpv4)
        .then((res) => {
          this.displayTableIpv4 = true;
          this.dataIpv4 = res.data
          this.totalRowsIpv4 = res.totalRows;
          this.tableLoadingIpv4 = false;
        })
        .catch((err) => {
          this.tableLoadingIpv4 = false;
          console.log(err);
        });
    },
    loadDataIpv6() {
      this.dataIpv6 = [];
      this.tableLoadingIpv6 = true;
      // this.displayTable = false;
      geolocationService
        .getAllGeolocation(this.searchParamsIpv6)
        .then((res) => {
          this.displayTableIpv6 = true;
          this.dataIpv6 = res.data
          this.totalRowsIpv6 = res.totalRows;
          this.tableLoadingIpv6 = false;
        })
        .catch((err) => {
          this.tableLoadingIpv6 = false;
          console.log(err);
        });
    },
    // onSortChangeIpv4(params) {
    //   this.sortField = params;
    //   this.loadDataIpv4();
    // },
    // clearFilters() {
    //   this.fieldsIpv4.forEach(field => {
    //     if (field.filterOptions && field.filterOptions.filterValue !== undefined) {
    //       field.filterOptions.filterValue = '';
    //     }
    //   });
    //   const query = { ...this.$route.query };
    //   Object.keys(query).forEach(key => {
    //     if (!['page', 'limit', 'lang'].includes(key)) {
    //       delete query[key];
    //     }
    //   });
    //   this.$router.replace({ query });
    //   this.$forceUpdate();
    // },
    updateDataIpv4() {
      this.loadDataIpv4();
    },
    updateDataIpv6() {
      this.loadDataIpv6();
    },

    onChangeFileIpv4(input) {
      console.log("onChangeFileIpv4: ", input);
      const file = input.target.files[0];
      this.fileIpv4 = file;
    },
    onChangeFileIpv6(input) {
      console.log("onChangeFileIpv6: ", input);
      const file = input.target.files[0];
      this.fileIpv6 = file;
    },
    onChangeFileAsn(input) {
      console.log("onChangeFileAsn: ", input);
      const file = input.target.files[0];
      this.fileAsn = file;
    },
    importIpv4Database() {
      this.importingIpv4Database = true;
      const formData = new FormData();
      
      if (this.fileIpv4) {
        formData.append("ipv4Database", this.fileIpv4);
      }
      const params = new URLSearchParams();
      params.append('indexElastic', true);

      geolocationService
        .importIpv4Database(formData, params)
        .then((job) => {
          this.importingIpv4Database = false;
          messagesNotifyHelper.successNotify(
            "Geolocalização",
            "Arquivo enviado. A importação continua em segundo plano."
          );
          this.onImportJobUpdated(job);
        })
        .catch((err) => {
          this.importingIpv4Database = false;
          this.onImportStartError(err);
        });
    },
    importIpv6Database() {
      this.importingIpv6Database = true;
      const formData = new FormData();
      
      if (this.fileIpv6) {
        formData.append("ipv6Database", this.fileIpv6);
      }
      const params = new URLSearchParams();
      params.append('indexElastic', true);

      geolocationService
        .importIpv6Database(formData, params)
        .then((response) => {
          if (response) {
            this.importingIpv6Database = false;
            messagesNotifyHelper.successNotify(
              "Geolocalização",
              "Importação feita com sucesso"
            );
          }
        })
        .catch((err) => {
          this.importingIpv6Database = false;
          messagesNotifyHelper.errorNotify(
            "Geolocalização",
            `Erro na importação: ${err}`
          )
          console.log(err);
        });
    },
    importAsnDatabase() {
      this.importingAsnDatabase = true;
      const formData = new FormData();
      
      if (this.fileAsn) {
        formData.append("asnDatabase", this.fileAsn);
      }
      const params = new URLSearchParams();
      params.append('indexElastic', true);

      geolocationService
        .importAsnDatabase(formData, params)
        .then((job) => {
          this.importingAsnDatabase = false;
          messagesNotifyHelper.successNotify(
            "Geolocalização",
            "Arquivo enviado. A importação continua em segundo plano."
          );
          this.onImportJobUpdated(job);
        })
        .catch((err) => {
          this.importingAsnDatabase = false;
          this.onImportStartError(err);
        });
    }
  }

};
</script>